import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthLoginComponent } from './auth-login/auth-login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AppRoutingModule } from './app-routing.module';
import {MatInputModule} from "@angular/material/input";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatListModule} from "@angular/material/list";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatMenuModule} from "@angular/material/menu";
import {AuthService} from "./services/auth.service";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import { IncidentsComponent } from './dashboard/incidents/incidents.component';
import { ReportsComponent } from './dashboard/reports/reports.component';
import {DropdownService} from "./services/dropdown.service";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatTableModule} from "@angular/material/table";
import {MatSelectModule} from "@angular/material/select";
import {MatTabsModule} from "@angular/material/tabs";
import { NewIncidentFormComponent } from './dashboard/incidents/new-incident-form/new-incident-form.component';
import { ViewIncidentRecordComponent } from './dashboard/incidents/view-incident-record/view-incident-record.component';
import {MatStepperModule} from "@angular/material/stepper";
import {MatBadgeModule} from "@angular/material/badge";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatTreeModule} from "@angular/material/tree";
import {MatDialog, MatDialogModule} from "@angular/material/dialog";
import {MatCheckboxModule} from "@angular/material/checkbox";
import { ReportPreviewComponent } from './shared/report-preview/report-preview.component';
import { ReportModifyFormComponent } from './dashboard/reports/report-modify-form/report-modify-form.component';
import {MatRadioModule} from "@angular/material/radio";
import { ViewIncidentsTblComponent } from './dashboard/incidents/view-incidents-tbl/view-incidents-tbl.component';
import { RptModifyImportIncidentComponent } from './dashboard/reports/report-modify-form/rpt-modify-import-incident/rpt-modify-import-incident.component';
import { SearchUniversalBasicComponent } from './shared/search-universal-basic/search-universal-basic.component';
import { EmailComponent } from './dashboard/email/email.component';
import { ComposeEmailComponent } from './dashboard/email/compose-email/compose-email.component';
import { ViewEmailListComponent } from './dashboard/email/view-email-list/view-email-list.component';
import { ViewEmailGroupsComponent } from './dashboard/email/view-email-groups/view-email-groups.component';
import { AddEmailListComponent } from './dashboard/email/add-email-list/add-email-list.component';
import { AddEmailGroupComponent } from './dashboard/email/add-email-group/add-email-group.component';
import {MatChipsModule} from "@angular/material/chips";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatSnackBar} from "@angular/material/snack-bar";
import { DetailChangeViewComponent } from './dashboard/detail/detail-change-view/detail-change-view.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import {DetailRowService, EditService, GridModule, ToolbarService} from '@syncfusion/ej2-angular-grids';
import { PageService, SortService, FilterService, GroupService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { TabModule } from '@syncfusion/ej2-angular-navigations';
import {DialogService} from "./services/dialog.service";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule} from "@angular/material/core";
import { DetailChangeHistoryComponent } from './dashboard/detail/detail-change-history/detail-change-history.component';
import { SettinsPlacesComponent } from './dashboard/settings/settins-places/settins-places.component';
import { MatFileUploadModule } from 'angular-material-fileupload';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { ChangeHistoryViewComponent } from './dashboard/detail/change-history-view/change-history-view.component';
import { ViewEmailReplytoListComponent } from './dashboard/email/view-email-replyto-list/view-email-replyto-list.component';
import { AddEmailReplytoListComponent } from './dashboard/email/add-email-replyto-list/add-email-replyto-list.component';
import { EmailLogsComponent } from './dashboard/email/email-logs/email-logs.component';
import { EntryRequestsComponent } from './entry-requests/entry-requests.component';
import { IncidentFormComponent } from './entry-requests/incident-form/incident-form.component';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from "@angular/material/form-field";
import { ReviewIncidentModificationComponent } from './entry-requests/review-incident-modification/review-incident-modification.component';
import { ComposeEmailShareEditComponent } from './dashboard/email/compose-email-share-edit/compose-email-share-edit.component';


@NgModule({
  declarations: [
    AppComponent,
    AuthLoginComponent,
    DashboardComponent,
    IncidentsComponent,
    ReportsComponent,
    NewIncidentFormComponent,
    ViewIncidentRecordComponent,
    ReportPreviewComponent,
    ReportModifyFormComponent,
    ViewIncidentsTblComponent,
    RptModifyImportIncidentComponent,
    SearchUniversalBasicComponent,
    EmailComponent,
    ComposeEmailComponent,
    ViewEmailListComponent,
    ViewEmailGroupsComponent,
    AddEmailListComponent,
    AddEmailGroupComponent,
    DetailChangeViewComponent,
    DetailChangeHistoryComponent,
    SettinsPlacesComponent,
    ChangeHistoryViewComponent,
    ViewEmailReplytoListComponent,
    AddEmailReplytoListComponent,
    EmailLogsComponent,
    EntryRequestsComponent,
    IncidentFormComponent,
    ReviewIncidentModificationComponent,
    ComposeEmailShareEditComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatIconModule,
    MatCardModule,
    ReactiveFormsModule,
    AppRoutingModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatExpansionModule,
    MatMenuModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatTableModule,
    MatSelectModule,
    MatTabsModule,
    MatStepperModule,
    MatBadgeModule,
    MatTooltipModule,
    MatTreeModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatChipsModule,
    MatAutocompleteModule,
    GridModule,
    TabModule,
    SweetAlert2Module.forRoot(),
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskModule.forRoot(),
    MatFileUploadModule,
    DropDownListAllModule
  ],
  providers: [
    AuthService,
    DialogService,
    MatSnackBar,
    PageService,
    SortService,
    FilterService,
    GroupService,
    DetailRowService,
    ResizeService,
    EditService,
    ToolbarService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
